//@flow
import React, { useState } from 'react';
import FormView from './FormView';

type Props = {
  type: string,
  presidentAgeOptions: Object,
  birthOnOptions: Object,
  businessTypeOptions: Object,
  fundraisingSimulationTags: Array<Object>,
  ecf: Object,
  plus: Object,
};

const PageView = (props: Props) => {
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (formId: 'form1' | 'form2' | null) => {
    setOpenAccordion(formId);
  };

  return (
    <div className="simulator__area">
      <FormView
        {...props.ecf}
        presidentAgeOptions={props.presidentAgeOptions}
        birthOnOptions={props.birthOnOptions}
        businessTypeOptions={props.businessTypeOptions}
        fundraisingSimulationTags={props.fundraisingSimulationTags}
        type="ecf"
        tagSortKey="ecf_order"
        onToggleAccordion={() => toggleAccordion('form1')}
        onCloseAccordion={() => toggleAccordion(null)}
        isOpen={openAccordion === 'form1'}
      />

      <FormView
        {...props.plus}
        presidentAgeOptions={props.presidentAgeOptions}
        birthOnOptions={props.birthOnOptions}
        businessTypeOptions={props.businessTypeOptions}
        fundraisingSimulationTags={props.fundraisingSimulationTags}
        type="plus"
        tagSortKey="plus_order"
        onToggleAccordion={() => toggleAccordion('form2')}
        onCloseAccordion={() => toggleAccordion(null)}
        isOpen={openAccordion === 'form2'}
      />
    </div>
  );
};

const renderPageView = (props: Props) => {
  return <PageView {...props} />;
};

export default renderPageView;
